(function($) {
    'use strict';

    $(function() {
        var $cart_mini = $('.cart_mini');
        var $cart_count = $cart_mini.find('.cart_mini__count');
        var url = $cart_mini.find('a').attr('href');
        var data = {
            action: 'update_minicart'
        };

        $cart_mini.addClass('loading');
        $cart_count.fadeOut(0);

        $.ajax({
            type: "post",
            url: url,
            data: data,
            dataType: 'json'
        })
            .done(function(data, textStatus, jqXHR) {

                if (data.error) {
                    console.error('error:', data.message);
                } else {
                    console.info('success:', data.message);

                    if ($cart_count.length) {
                        $cart_count.html(data.markup);
                        $cart_count.fadeIn();
                    }
                }
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                console.log('ajax failed', textStatus);
                alert(errorThrown);
            })
            .always(function(datajqXHR, textStatus, jqXHRerrorThrown) {
                $cart_mini.removeClass('loading');
            });
    });

} (jQuery));